export default function initSlick() {
    const prevArrow = (className) =>
        '<button type="button" class="slick-prev ' +
        className +
        '" aria-label="Anterior">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="70" height="71" viewBox="0 0 70 71" fill="none">' +
        '<path d="M55.8335 35.1079L15.0002 35.1079" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M35 55.5247L14.5833 35.108L35 14.6913" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>" +
        "</button>";

    const nextArrow = (className) =>
        '<button type="button" class="slick-next ' +
        className +
        '" aria-label="Próximo">' +
        '<svg xmlns="http://www.w3.org/2000/svg" width="70" height="71" viewBox="0 0 70 71" fill="none">' +
        '<path d="M14.5835 35.1079H55.4168" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M35 14.6912L55.4167 35.1078L35 55.5245" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>" +
        "</button>";

    $(".slider-obras").slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: $(".slider-obras > .item").length - 1,
        swipe: false,
        fade: true,
        cssEase: "linear",
        prevArrow: prevArrow("slick-prev-slider-obras"),
        nextArrow: nextArrow("slick-next-slider-obras"),
    });

    $(".slider-obras-fotos").slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: false,
        fade: true,
        cssEase: "linear",
        prevArrow: prevArrow("slick-prev-slider-obras-fotos"),
        nextArrow: nextArrow("slick-next-slider-obras-fotos"),
    });

    $(".slider-obras-videos").slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: false,
        fade: true,
        cssEase: "linear",
        prevArrow: prevArrow("slick-prev-slider-obras-videos"),
        nextArrow: nextArrow("slick-next-slider-obras-videos"),
    });

    $(".slider-galeria").slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: prevArrow(),
        nextArrow: nextArrow(),
    });

    $(".slider-galeria-lazer-terreo").slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1.15,
        prevArrow: prevArrow(),
        nextArrow: nextArrow(),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $(".slider-galeria-lazer-sexto-pavimento").slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1.15,
        prevArrow: prevArrow(),
        nextArrow: nextArrow(),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    });

    $(".slider-plantas").slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: "linear",
        prevArrow: prevArrow(),
        nextArrow: nextArrow(),
    });

    $(".galeria-mosaico").slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: prevArrow(),
        nextArrow: nextArrow(),
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 700,
                settings: "unslick",
            },
        ],
    });
}
